// src/utils/generateImageFromPrompt.js
import axios from 'axios';

export const generateImageFromPrompt = async (prompt) => {
  const apiKey = process.env.REACT_APP_OPENAI_API_KEY;

  try {
    const response = await axios.post(
      'https://api.openai.com/v1/images/generations',
      {
        prompt,
        n: 1,
        size: '512x512',
        response_format: 'b64_json'
      },
      {
        headers: {
          'Authorization': `Bearer ${apiKey}`,
          'Content-Type': 'application/json'
        }
      }
    );

    const base64 = response.data.data[0].b64_json;
    return `data:image/png;base64,${base64}`;
  } catch (err) {
    console.error('❌ Error generating image:', err);
    throw err;
  }
};
